import { ReadyState, SendMessage } from "react-use-websocket";
import {
    INotificationMessageIncoming,
    IOpenNotificationActionPayload,
    IReceiveNotificationMessagePayload,
    ISendNotificationMessagePayload,
    ISetNotificationsMessagePayload,
    ISetNotificationsWsReadyStatePayload,
    ISetNotificationsWsSendMessageFnPayload,
    TNotificationMessageTypes
} from "./notifications.t";
import { Id } from "react-toastify";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { LOGOUT_SUCCESS } from "../Login/loginConstants";

export interface INotificationsState {
    isShowAccountEventIndicator: boolean,
    messages: { [type in TNotificationMessageTypes]?: INotificationMessageIncoming['params'] },
    sendMessagesQueue: SendMessage[],
    showMessagesQueue: INotificationMessageIncoming[],
    showedMessage: INotificationMessageIncoming,
    showedToasts: Id[],
    toast: IOpenNotificationActionPayload,
    websocketInstance: WebSocket | null,
    wsReadyState: ReadyState,
    wsSendMessageFn: SendMessage,
}

const initialState: INotificationsState = {
    isShowAccountEventIndicator: false,
    messages: {},
    sendMessagesQueue: [],
    showMessagesQueue: [],
    showedMessage: undefined,
    showedToasts: [],
    toast: null,
    websocketInstance: null,
    wsReadyState: ReadyState.UNINSTANTIATED,
    wsSendMessageFn: () => {
    },
}

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setNotificationMessageAction(state, action: PayloadAction<ISetNotificationsMessagePayload>) {
            state.messages[action.payload.type] = action.payload.params;
        },
        setNotificationsWsReadyState(state, action: PayloadAction<ISetNotificationsWsReadyStatePayload>) {
            state.wsReadyState = action.payload;
        },
        setNotificationsWsSendMessageFn(state, action: PayloadAction<ISetNotificationsWsSendMessageFnPayload>) {
            state.wsSendMessageFn = action.payload;
        },

        openNotificationAction(state, action: PayloadAction<IOpenNotificationActionPayload>) {
            state.toast = action.payload;
        },

        openNotificationToastAction(state, action: PayloadAction<Id>) {
            state.showedToasts = _.cloneDeep(state.showedToasts).concat(action.payload);
        },
        closeNotificationToastAction(state, action: PayloadAction<Id>) {
            state.showedToasts = state.showedToasts.filter((toast) => toast !== action.payload);
        },


        addNotificationToQueueAction(state, action: PayloadAction<ISetNotificationsMessagePayload>) {
            state.showMessagesQueue = _.cloneDeep(state.showMessagesQueue).concat(action.payload);
        },
        showNotificationFromQueueAction(state) {
            state.showedMessage = state.showMessagesQueue[0];
            state.showMessagesQueue = state.showMessagesQueue.slice(1);
        },
        closeNotificationFromQueueAction(state) {
            state.showedMessage = undefined;
        },

        receiveNotificationMessageAction(state, action: PayloadAction<IReceiveNotificationMessagePayload>) {
        },
        sendNotificationMessageAction(state, action: PayloadAction<ISendNotificationMessagePayload>) {
        },

        setIsShowAccountEventIndicatorAction(state, action: PayloadAction<boolean>) {
            state.isShowAccountEventIndicator = action.payload;
        },

        setNotificationWebsocketInstanceAction(state, action: PayloadAction<WebSocket>) {
            state.websocketInstance = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(LOGOUT_SUCCESS, (state) => {
            Object.assign(state, initialState, {
                websocketInstance: state.websocketInstance,
                wsSendMessageFn: state.wsSendMessageFn,
                wsReadyState: state.wsReadyState
            });
        })
    },
});

export const {
    addNotificationToQueueAction,
    closeNotificationFromQueueAction,
    closeNotificationToastAction,
    openNotificationAction,
    openNotificationToastAction,
    receiveNotificationMessageAction,
    sendNotificationMessageAction,
    setNotificationMessageAction,
    setNotificationsWsReadyState,
    setNotificationsWsSendMessageFn,
    showNotificationFromQueueAction,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;
